import { render, staticRenderFns } from "./dataAuth.vue?vue&type=template&id=588dd576&scoped=true"
import script from "./dataAuth.vue?vue&type=script&lang=js"
export * from "./dataAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588dd576",
  null
  
)

export default component.exports